import voucherServices from '@/services/voucher'
import * as types from './mutation-types'

export const EmployeeProfile = async ({ commit }, data) => {
    return voucherServices.EmployeeProfile(data)
        .then((result) => commit(types.GET_EMPLOYEE, result.data))
        .catch(() => {})
}